import './src/styles/reset.css';
import './src/styles/main.css';
import './src/styles/slick.css';
import './src/styles/slick-theme.css';
import './static/assets/fonts/fonts.css';
